import React, { useState, useEffect } from "react";
import { FaArrowRight } from "react-icons/fa6";
import { IoMdClose } from "react-icons/io";
import { RolePermissionsModal } from "./RolePermissionsModal";

export const EditRoleModal = ({
  onClose,
  isOpen,
  roleData: initialRoleData,
}) => {
  const [roleData, setRoleData] = useState({
    name: "",
    description: "",
    status: "active",
    role_type: "Admin",
    permissions: [],
  });

  const [showFilters, setShowFilters] = useState(true);
  const [isPermissionsModalOpen, setPermissionsModalOpen] = useState(false);

  // Initialize form with role data when the modal opens
  useEffect(() => {
    if (initialRoleData) {
      setRoleData({
        name: initialRoleData.role || "",
        description: initialRoleData.description || "",
        status: initialRoleData.status === "Active" ? "active" : "inactive",
        role_type: initialRoleData.roleType || "Admin",
        permissions: initialRoleData.permissions || [],
      });
      setShowFilters(initialRoleData.status === "Active");
    }
  }, [initialRoleData]);

  const handleInputChange = (field, value) => {
    setRoleData((prev) => ({ ...prev, [field]: value }));
  };

  const handleToggleChange = (checked) => {
    setShowFilters(checked);
    setRoleData((prev) => ({
      ...prev,
      status: checked ? "active" : "inactive",
    }));
  };

  const handleSavePermissions = (permissions) => {
    setRoleData((prev) => ({
      ...prev,
      permissions,
    }));

    console.log("Updated permissions:", permissions);
  };

  const handleSubmit = () => {
    // Here you would handle updating the role data
    console.log("Updated role data:", roleData);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-[450px] p-6 gap-4 flex flex-col">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-semibold text-[#FF9348]">Edit Role</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-black">
            <IoMdClose size={24} />
          </button>
        </div>

        <div>
          <p className="font-medium">
            Role<span className="text-red-500">*</span>
          </p>
          <input
            type="text"
            value={roleData.name}
            onChange={(e) => handleInputChange("name", e.target.value)}
            placeholder="Enter Role Name"
            className="w-full border border-gray-400 rounded-md px-2 py-2"
          />
        </div>

        <div>
          <p className="font-medium">
            Description<span className="text-red-500">*</span>
          </p>
          <input
            type="text"
            value={roleData.description}
            onChange={(e) => handleInputChange("description", e.target.value)}
            placeholder="Enter Role Description"
            className="w-full border border-gray-400 rounded-md p-2 pb-24"
          />
        </div>

        <div className="flex flex-row justify-between items-center font-medium">
          <p>Role Status</p>
          <div className="flex items-center gap-2">
            <span
              className={`text-sm font-medium ${
                showFilters ? "text-blue-600" : ""
              }`}
            >
              {showFilters ? "Active" : "InActive"}
            </span>
            <label className="relative inline-flex items-center justify-between cursor-pointer">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={showFilters}
                onChange={(e) => handleToggleChange(e.target.checked)}
              />
              <div
                className="relative w-9 h-5 bg-gray-200 rounded-full peer 
                after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:right-[2px] 
                after:bg-white after:rounded-full after:h-4 after:w-4
                after:transition-all peer-checked:bg-blue-600 
                peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full"
              ></div>
            </label>
          </div>
        </div>

        <div className="flex flex-row items-center gap-4 w-full">
          <button
            onClick={onClose}
            className="w-1/2 py-2 border border-gray-300 rounded-md"
          >
            Cancel
          </button>
          <button
            onClick={() => setPermissionsModalOpen(true)}
            className="flex flex-row items-center justify-center gap-2 text-white bg-blue-600 w-1/2 py-2 border border-gray-300 rounded-md"
          >
            Role Access
            <FaArrowRight />
          </button>
        </div>
      </div>

      {isPermissionsModalOpen && (
        <RolePermissionsModal
          isOpen={isPermissionsModalOpen}
          onClose={() => setPermissionsModalOpen(false)}
          onSave={handleSavePermissions}
          initialPermissions={roleData.permissions}
          title="Edit Role"
          saveButtonText="Update Role"
          mode="edit"
        />
      )}
    </div>
  );
};
